<div class="dialog" fxLayout="column">

  <div mat-dialog-header>
    <div class="dialog-title" fxLayout="row" fxLayoutAlign="space-between end">
      <div fxLayout="row" fxLayoutGap="10px">
        <mat-icon>create</mat-icon>
        <h1 *ngIf="!isAdded">{{'施設職員情報：編集' | translate}}</h1>
        <h1 *ngIf="!!isAdded">{{'施設職員情報：追加' | translate}}</h1>
      </div>

      <div fxLayout="row" fxLayoutGap="10px">
        <button mat-raised-button color="primary" (click)="addUser()" [disabled]="!userFormGroup.valid">
          <mat-icon>add</mat-icon>
          <span *ngIf="!isAdded">{{'更新' | translate}}</span>
          <span *ngIf="!!isAdded">{{'追加' | translate}}</span>
        </button>
        <button mat-button (click)="onNoClick()">
          <mat-icon>clear</mat-icon>
        </button>
      </div>
    </div>
  </div>

  <div mat-dialog-content fxFlex="600px" style="overflow: auto;">
    <form class="form" [formGroup]="userFormGroup">
      <div class="dialog-body" fxLayout="row" fxLayoutGap="20px">
        <div class="dialog-left" fxLayout="column" fxFlex="50%" fxLayoutGap="20px">
          <mat-form-field fxFlex="100%" *ngIf="!isAdded">
            <mat-label floatLabel="always">ID</mat-label>
            <input matInput placeholder="ID" id="uid" formControlName="uid" readonly>
          </mat-form-field>

          <mat-form-field fxFlex="100%">
            <mat-label floatLabel="always">{{'メールアドレス' | translate}}</mat-label>
            <input matInput placeholder="{{'メールアドレス' | translate}}" id="email" formControlName="email">
            <mat-error *ngIf="emailControl.invalid">{{ getErrorMessageToEmail() }}</mat-error>
          </mat-form-field>

          <mat-form-field fxFlex="100%">
            <mat-label floatLabel="always">{{'名称' | translate}}</mat-label>
            <input matInput placeholder="{{'名称' | translate}}" id="name" formControlName="name">
            <mat-error *ngIf="nameControl.invalid">{{ getErrorMessageToName() }}</mat-error>
          </mat-form-field>

          <div fxLayout="row" fxLayoutAlign="space-between end">
            <span>{{'施設リスト（' | translate}} {{ !!user!.facility_ids ? user!.facility_ids.length:0 }} {{'件' | translate}}）</span>
            <button mat-stroked-button (click)="openSelectFacilitiesDialog()">
              <mat-icon>add</mat-icon>
              <span>{{'施設リスト追加' | translate}}</span>
            </button>
          </div>

          <table>
            <thead>
              <tr>
                <th>ID</th>
                <th>{{'名称' | translate}}</th>
                <th>{{'削除' | translate}}</th>
              </tr>
            </thead>
            <tbody cdkDropList class="cdk-table">
              <tr *ngFor="let facility of facilities" cdkDrag cdkDragLockAxis="y">
                <td>{{ facility.facility_id }}</td>
                <td>{{ facility.facility_names | multiName:projectLanguages:projectBaseLang }}</td>
                <td>
                  <button mat-stroked-button color="warn" (click)="deleteFacility(facility.id!)">
                    <mat-icon>clear</mat-icon>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="dialog-right" fxLayout="column" fxFlex="50%" fxLayoutGap="20px">

          <mat-form-field fxFlex="100%">
            <mat-label floatLabel="always">{{'詳細' | translate}}</mat-label>
            <textarea matInput placeholder="{{'詳細' | translate}}" id="description" formControlName="description" rows="11"></textarea>
            <mat-error *ngIf="descriptionControl.invalid">{{ getErrorMessageToDescription() }}</mat-error>
          </mat-form-field>

        </div>

      </div>
    </form>
  </div>


</div>